/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from './api';

export const useDirectory = () =>
  useQuery({ queryKey: ['users-directory'], queryFn: () => api.get<{ id: string; fullName: string; email: string }[]>('/users/directory'), staleTime: 300_000 });

export const useDict = (dict: string) =>
  useQuery({ queryKey: ['dict', dict], queryFn: () => api.get<{ id: string; code: string; name: string; isActive: boolean }[]>(`/dictionaries/${dict}`), staleTime: 300_000 });

export function useDebounced<T>(value: T, ms = 300) {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
}
